import React from 'react';
import { SVGIcon } from '../../../components/atoms/SVG';
import { WidgetType } from '../../../types/api/ElementType';
import { Block, isEmptyBlock, isNonEmptyBlock } from '../../../types/api/Block';
import { DefaultWidgetWithHeader } from '../../../_lib/components/Widget';
import { ContextWidget } from '../../../types/api/Widget';

type WidgetProps = {
  icon: SVGIcon;
  title: string;
};

export function asDefaultWidget<TBlock extends Block, TWidget extends WidgetType>(
  blockToComponent: React.FC<TBlock>
): React.FC<ContextWidget<TBlock, TWidget> & WidgetProps> {
  function DefaultWidget({
    blocks,
    uuid,
    elementType,
    icon,
    title,
    header,
  }: ContextWidget<TBlock, TWidget> & WidgetProps) {
    if (blocks.every(isEmptyBlock)) {
      return null;
    }

    return (
      <DefaultWidgetWithHeader
        key={`${uuid}-${elementType}`}
        widgetType={elementType}
        uuid={uuid}
        icon={icon}
        title={title}
        header={header}
      >
        {blocks.filter(isNonEmptyBlock).map(blockToComponent as any)}
      </DefaultWidgetWithHeader>
    );
  }
  return DefaultWidget;
}
